import { t } from '@lingui/macro';

export const maintenanceGraphsColors = [
  '#8c00ff',
  '#00cc00',
  '#8b4513',
  '#0000de',
  '#bda400',
  '#ff0090',
  '#008b8b',
  '#ff2934',
  '#006400',
  '#FFA500',
];

export const SignalGraphs = ['csq', 'ecl', 'rsrp', 'rsrq'] as const;
export type SignalGraphsType = (typeof SignalGraphs)[number];

export const signalGraphTitlesFn = (): Record<SignalGraphsType, string> => ({
  csq: t({ message: 'Signal - CSQ', id: '[SignalCSQBattery.CSQ]' }),
  ecl: t({ message: 'Signal - ECL', id: '[SignalCSQBattery.ecl]' }),
  rsrp: t({ message: 'Signal - RSRP', id: '[SignalCSQBattery.rsrp]' }),
  rsrq: t({ message: 'Signal - RSRQ', id: '[SignalCSQBattery.rsrq]' }),
});
